<template>
    <span><a href="/admin/dashboard">Admin dashboard</a></span>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
